import { LocaleProvider } from '../ContextProviders/LocaleProvider';
import { Seo } from '../Seo';
import { Footer } from './Footer';
import { Header } from './Header';

export const PageWrapper = ({
  children,
  seoTitle,
  seoDescription,
  seoImage,
  fullWidth,
  footerRef,
  pageData,
}) => (
  <LocaleProvider pageData={pageData}>
    <Seo
      seoTitle={seoTitle}
      seoDescription={seoDescription}
      seoImage={seoImage}
    />
    <Header fullWidth={fullWidth} />
    <main id="__smastrom">{children}</main>
    <Footer footerRef={footerRef || null} fullWidth={fullWidth} />
  </LocaleProvider>
);
